/**
 * 발굴(인플루언서) 문서의 **id 규칙** — `{채널}_{계정}` 이되 계정의 `.` 는 `_` 로 바뀐다.
 *
 * ⛔ **점을 그대로 이어 붙이면 찾지 못한다** — 색인이 `kimyoojin.n` 을 `instagram_kimyoojin_n` 으로 짓는다.
 *   인스타·틱톡 아이디에 점이 흔해, 이 한 글자 때문에 얼굴·팔로워·프로필이 통째로 비어 보인다.
 * ⚠️ 대소문자는 **그대로** 둔다(`x_KylieJenner`) — 소문자로 바꾼 것은 표기가 엇갈릴 때를 위한 덤이다.
 */

/** 문서 id 한 벌 — 색인이 짓는 규칙 그대로 */
export function toInfluencerDocId(channel: string, account: string): string {
  return `${channel.trim()}_${account.trim().replace(/\./g, '_')}`;
}

/**
 * 한 계정을 찾을 때 함께 싣는 id 변형 — 표기 차이(점 · 대소문자)를 덮는다.
 * @returns 겹치지 않는 id. 채널이나 계정이 비면 빈 목록
 */
export function toInfluencerDocIdVariants(channel: string, account: string): string[] {
  const source = channel.trim();
  const name = account.trim();
  if (!source || !name) return [];
  return [...new Set([
    `${source}_${name}`,
    toInfluencerDocId(source, name),
    `${source}_${name.toLowerCase()}`,
    toInfluencerDocId(source, name.toLowerCase()),
  ])];
}
